import { useStyletron } from '@thanx/uikit/theme'
import BookOutline from 'components/Icons/BookOutline'
import QuestionCircleOutline from 'components/Icons/QuestionCircleOutline'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import { enableDisableLocations, orderingManagement } from 'utilities/urlUtils'

const t = buildTranslate('locations.location_list')

// Help-link footer rendered at the bottom of the Locations and Menu
// errors tabs (and the location detail page). The (?) icon inherits
// the parent's grey90 alongside the "Help" label, and the trailing
// book icons match the link text colour via currentColor so they read
// as part of the link itself.
const HelpLinks = () => {
  const [css] = useStyletron()
  const linkClass = `d-block body-text-4 mb-xxs ${css({
    color: palette.belizeHole,
    textDecoration: 'none',
    ':hover': { textDecoration: 'underline' },
  })}`
  return (
    <div className="mt-l">
      <div
        className={`d-flex align-items-center mb-xs bold ${css({
          color: palette.grey90,
        })}`}
      >
        <QuestionCircleOutline className="mr-xs" />
        {t('help.title')}
      </div>
      {/* Both links target an external help site, so each carries a
          visually-hidden "opens in a new tab" cue for SR users — the
          `BookOutline` icon is aria-hidden and `target="_blank"` alone
          doesn't surface the new-context warning. (.sr-only is a
          Bootstrap utility class already in use elsewhere in this
          repo — see ThanxAISuggestionList / SampleCustomersContent.) */}
      <a
        href={enableDisableLocations}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClass}
      >
        {t('help.enable_disable')}
        <span className="sr-only"> ({t('help.opens_in_new_tab')})</span>
        <BookOutline className="ml-xxs" />
      </a>
      <a
        href={orderingManagement}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClass}
      >
        {t('help.troubleshoot_menu_errors')}
        <span className="sr-only"> ({t('help.opens_in_new_tab')})</span>
        <BookOutline className="ml-xxs" />
      </a>
    </div>
  )
}

export default HelpLinks
